<template>
	<div class="login-container">
		<el-card class="login-card">
			<div class="title">
				<h2>Ai研报管理系统</h2>
			</div>
			<el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-width="0px">
				<el-form-item prop="username">
					<el-input
						v-model="loginForm.username"
						prefix-icon="el-icon-user"
						placeholder="用户名"
					></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input
						v-model="loginForm.password"
						prefix-icon="el-icon-lock"
						show-password
						placeholder="密码"
					></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" :loading="loading" @click="handleLogin" style="width: 100%"
						>登录</el-button
					>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
export default {
	name: 'LoginPage',
	data() {
		return {
			loginForm: {
				username: 'admin',
				password: '123456',
			},
			loginRules: {
				username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					{ min: 6, message: '密码长度至少6个字符', trigger: 'blur' },
				],
			},
			loading: false,
		};
	},
	methods: {
		handleLogin() {
			this.$refs.loginForm.validate(valid => {
				if (valid) {
					this.loading = true;
					this.$store
						.dispatch('login', this.loginForm)
						.then(() => {
							this.$message.success('登录成功');
							this.$router.push('/');
						})
						.catch(error => {
							this.$message.error(error.message || '登录失败');
						})
						.finally(() => {
							this.loading = false;
						});
				} else {
					return false;
				}
			});
		},
	},
};
</script>

<style scoped>
.login-container {
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #f0f2f5;
}
.login-card {
	width: 400px;
}
.title {
	text-align: center;
	margin-bottom: 20px;
}
</style>
